import React from 'react'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'

import '../../../stylesheets/components/dtcs/index.scss'
import DtcsListing from '../../../components/dtcs/TATMappings/DtcsListing'
import TatStore from '../../../components/dtcs/TATMappings/context/context'
import Memos from '../../../components/dtcs/Memos'
import MemoStore from '../../../components/dtcs/Memos/context/context'
import TracerMapping from '../../../components/dtcs/TracerMapping'
import TracerMappingStore from '../../../components/dtcs/TracerMapping/context/context'

const DtcApp = ({}) => {
  return (
    <Tabs variant="fullWidth" style={{ width: '100%' }}>
      <TabList>
        <Tab>Tracer Authoring Mappings</Tab>
        <Tab>Tracer Mappings</Tab>
        <Tab>Memos</Tab>
      </TabList>

      <TabPanel>
        <TatStore>
          <DtcsListing />
        </TatStore>
      </TabPanel>
      <TabPanel>
        <TracerMappingStore>
          <TracerMapping />
        </TracerMappingStore>
      </TabPanel>
      <TabPanel>
        <MemoStore>
          <Memos />
        </MemoStore>
      </TabPanel>
    </Tabs>
  )
}

DtcApp.propTypes = {}

export default DtcApp
